/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Grid } from '@mui/material';
import React from 'react'
import { Box } from '@mui/system';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import SplunkUsersList from '../views/SplunkUsersList';
import SplunkUserCreation from '../views/CreateSplunkUser';

const ManageSplunkPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Splunk Users'} />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <SplunkUserCreation />
                    </Grid>



                    <Grid item xs={12} sm={12} md={12}>
                        <SplunkUsersList />
                    </Grid>
                </Grid>
            </Box>

        </>
    )
}

export default ManageSplunkPage;